import ModuleFactory from "./pqe.browser.es.js";
let module = null;
export async function initCrystals() {
    module = await ModuleFactory();
    const data = new Uint8Array(48);
    self.crypto.getRandomValues(data);
    module.initEntropy(data);
    return module;
}
export function generateKeyPair() {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    const data = new Uint8Array(48);
    self.crypto.getRandomValues(data);
    return module.generateKeyPairFromData(data);
}
export function generateKeyPairFrom(keyMaterial) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!keyMaterial) {
        throw new Error("No data supplied to crystals generateKeyPairFrom");
    }
    if (typeof keyMaterial === "string") {
        return module.generateKeyPairFrom(keyMaterial);
    }
    if (keyMaterial.length <= 0) {
        throw new Error("No data supplied to crystals.generateKeyPairFrom");
    }
    return module.generateKeyPairFromData(keyMaterial);
}
export function exportKeyToBase64(key) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!key) {
        throw new Error("No key supplied to crystals exportKeyToBase64");
    }
    return key.exportKeyToBase64();
}
export function exportKey(key) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!key) {
        throw new Error("No key supplied to crystals exportKey");
    }
    return key.exportKey();
}
export function publicKeyFrom(data) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!data) {
        throw new Error("No data supplied to crystals publicKeyFrom");
    }
    try {
        if (typeof data === "string") {
            return module.publicKeyFromBase64(data);
        }
        if (data.length <= 0) {
            throw new Error("No data supplied to crystals publicKeyFrom");
        }
        return module.publicKeyFrom(data);
    }
    catch (err) {
        throw new Error("Failed importing kyber public key");
    }
}
export function privateKeyFrom(data) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!data) {
        throw new Error("No data supplied to crystals privateKeyFrom");
    }
    try {
        if (typeof data === "string") {
            return module.privateKeyFromBase64(data);
        }
        if (data.length <= 0) {
            throw new Error("No data supplied to crystals.privateKeyFrom");
        }
        return module.privateKeyFrom(data);
    }
    catch (err) {
        throw new Error("Failed importing kyber private key");
    }
}
export function encrypt(buffer, publicKey) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!publicKey) {
        throw new Error("Missing publicKey in crystals.encrypt");
    }
    if (buffer.length <= 0) {
        throw new Error("Empty buffer supplied to encrypt");
    }
    return module.encrypt(buffer, publicKey);
}
export function decrypt(buffer, privateKey) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!privateKey) {
        throw new Error("Missing privateKey in crystals.decrypt");
    }
    if (buffer.length <= 0) {
        throw new Error("Empty buffer supplied to decrypt");
    }
    try {
        return module.decrypt(buffer, privateKey);
    }
    catch (err) {
        console.error("Error:", err);
        throw new Error("Decryption Failed");
    }
}
export function generateSigningKeyPair() {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    const data = new Uint8Array(48);
    self.crypto.getRandomValues(data);
    return module.generateSigningKeyPairFromData(data);
}
export function generateSigningKeyPairFrom(keyMaterial) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!keyMaterial) {
        throw new Error("No keyMaterial supplied to crystals.generateSigningKeyPairFrom");
    }
    if (typeof keyMaterial === "string") {
        return module.generateSigningKeyPairFrom(keyMaterial);
    }
    if (keyMaterial.length <= 0) {
        throw new Error("No data supplied to crystals.generateSigningKeyPairFrom");
    }
    return module.generateSigningKeyPairFromData(keyMaterial);
}
export function publicSigningKeyFrom(data) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!data) {
        throw new Error("No data supplied to crystals publicSigningKeyFrom");
    }
    try {
        if (typeof data === "string") {
            return module.publicSigningKeyFromBase64(data);
        }
        if (data.length <= 0) {
            throw new Error("No data supplied to crystals.publicSigningKeyFrom");
        }
        return module.publicSigningKeyFrom(data);
    }
    catch (err) {
        throw new Error("Failed importing dilithium public key");
    }
}
export function privateSigningKeyFrom(data) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!data) {
        throw new Error("No data supplied to crystals privateSigningKeyFrom");
    }
    try {
        if (typeof data === "string") {
            return module.privateSigningKeyFromBase64(data);
        }
        if (data.length <= 0) {
            throw new Error("No data supplied to crystals.privateSigningKeyFrom");
        }
        return module.privateSigningKeyFrom(data);
    }
    catch (err) {
        throw new Error("Failed importing dilithium private key");
    }
}
export function sign(data, privateKey) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!data || data.length <= 0) {
        throw new Error("No data supplied to crystals.sign");
    }
    return module.sign(data, privateKey);
}
export function verify(signature, data, publicKey) {
    if (!module) {
        throw new Error("Please, initialize the kyber module!");
    }
    if (!data || data.length <= 0) {
        throw new Error("No data supplied to crystals.verify");
    }
    if (!signature || signature.length <= 0) {
        throw new Error("No signature supplied to crystals.verify");
    }
    return module.verify(signature, data, publicKey);
}
